<template>
  <tinymce-editor
    v-model="content"
    :init="init"
    @input="input"
  ></tinymce-editor>
</template>

<script>
import { uploadImg, uploadVideo } from "@/api/upload";
import Editor from "@tinymce/tinymce-vue";
export default {
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  components: {
    "tinymce-editor": Editor
  },
  created() {
    this.content = this.value;
  },
  data() {
    return {
      content: "",
      init: {
        menubar:false,
        language: "zh_CN",
        height: 600,
        plugins:
          "link lists image media code table colorpicker textcolor wordcount contextmenu emoticons lineheight table",
        toolbar:
          "bold italic underline strikethrough | fontsizeselect | lineheight | forecolor backcolor | alignleft aligncenter alignright alignjustify|bullist |outdent indent blockquote | undo redo | link unlink image media code | removeformat table",
        branding: false,
        fontsize_formats: "10px 12px 14px 16px 18px 20px 22px 24px",
        content_style:'p,blockquote {margin-top:0;margin-bottom:0;} img {width:100%;height:auto;outline-width:0px;vertical-align:top;} ul,ol {padding:revert;margin:0}',
        lineheight_formats: '1 1.5 1.75 2 3 4 5',
        images_upload_handler: (blobInfo, success, failure) => {
          const file = blobInfo.blob();
          if (file.size > 5242880) {
            failure("图片请不要大于 5MB");
            return;
          }

          const formData = new FormData();
          formData.append("file", file);
          uploadImg(formData).then(res => {
            const { data } = res;
            success(data);
          });
        },
        file_picker_types: "media",
        file_picker_callback: (cb, value, meta) => {
          if (meta.filetype === "media") {
            const input = document.createElement("input");
            input.setAttribute("type", "file");
            input.onchange = () => {
              const file = input.files[0];
              const formData = new FormData();
              formData.append("file", file);

              uploadVideo(formData).then(res => {
                const { data } = res;
                cb(data, {
                  title: file.name
                });
              });
            };
            input.click();
          }
        },
        paste_preprocess: (pl, o) => {
          o.content = $stripTags(o.content, "sup,sub");
        }
      }
    };
  },
  methods: {
    blobToFile(blob, fileName) {
      const file = new File([blob], fileName, { type: blob.type });
      return file;
    },
    input(value) {
      this.$emit("input", value);
    }
  }
};
</script>

<style>
.tox .tox-notifications-container .tox-notification {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/TinymceNew/index.vue